module.exports = __webpack_public_path__ + "static/images/haed1.f04a84e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/race/haed1.jpg
// module id = pgUL
// module chunks = 1